import keycloak from './keycloak';

const isMigrationFailed = () =>
    keycloak.tokenParsed &&
    keycloak.tokenParsed.migrationStatus &&
    keycloak.tokenParsed.migrationStatus.status !== 'SUCCESS';

/**
 * Check and refresh (if needed) keycloak token
 */
export const checkRefreshToken = () =>
    keycloak
        .updateToken()
        .then(() => Promise.resolve())
        .catch(
            // ignore network / refresh errors since the downstream code has all error handling
            () => Promise.resolve(),
        );

export { isMigrationFailed };
